import { BAOCustomElement } from '@bao/custom-element'
import { eventBus, EVENTS } from '@bao/events'

export class ProductOptions extends BAOCustomElement() {
  static get requiredElements () {
    return ['option', 'selected-variant']
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this, 'change', this.onProductOptionChange.bind(this))

    for (const option of this.els.option.elements) {
      this.listeners.add(
        option,
        'mouseenter',
        this.onProductOptionEnter.bind(this),
      )
    }
  }

  onProductOptionChange (event) {
    const target =
      event.target.tagName === 'SELECT'
        ? event.target.selectedOptions[0]
        : event.target

    eventBus.dispatchEvent(EVENTS.PRODUCT.OPTION_SELECTED, {
      event,
      target,
      selectedOptionValues: this.selectedOptionValues,
    })
  }

  onProductOptionEnter (event) {
    eventBus.dispatchEvent(EVENTS.PRODUCT.OPTION_ENTERED, {
      event,
      selectedOptionValues: this.selectedOptionValues,
    })
  }

  get selectedOptionValues () {
    const selectedOptions = Array.from(this.querySelectorAll('select')).flatMap(
      (select) =>
        Array.from(select.selectedOptions).map(
          (option) => option.dataset.optionValueId,
        ),
    )

    const checkedInputs = Array.from(
      this.querySelectorAll('fieldset input:checked'),
    ).map((input) => input.dataset.optionValueId)

    return [...selectedOptions, ...checkedInputs]
  }

  get selectedVariant () {
    return JSON.parse(this.els['selected-variant'].element.innerHTML)
  }
}

if (!customElements.get('product-options')) {
  customElements.define('product-options', ProductOptions)
}
